var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResivePayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_53",
    x: 0,
    y: 0,
    width: 105,
    height: 105,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4132",
    "data-name": "Rectangle 4132",
    width: 38.316,
    height: 32.847,
    fill: "#393939"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9149",
    "data-name": "Group 9149",
    transform: "translate(9.42 6.054)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.42, -6.05)",
    filter: "url(#Ellipse_53)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_53-2",
    "data-name": "Ellipse 53",
    cx: 43.5,
    cy: 43.5,
    r: 43.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11331",
    "data-name": "Group 11331",
    transform: "translate(23.58 26.946)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11330",
    "data-name": "Group 11330",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M35.588,23a.18.18,0,0,1,.026-.023,14.8,14.8,0,0,1-2.776.271,1.654,1.654,0,0,1,.017.171c0,.84.022,1.683,0,2.524a4.1,4.1,0,0,1-2.038,3.585,3.679,3.679,0,0,1-1.692.542c-.362.024-.726.04-1.089.04q-10.4,0-20.79,0a4.969,4.969,0,0,1-1.585-.195,4.031,4.031,0,0,1-2.784-2.93,4.217,4.217,0,0,1-.135-1.078Q2.727,16.456,2.734,7a4.123,4.123,0,0,1,.5-2.1,4.075,4.075,0,0,1,2.754-2.06,4.637,4.637,0,0,1,.973-.11q10.813-.01,21.626,0a4.225,4.225,0,0,1,2.95,1.11A3.879,3.879,0,0,1,32.717,5.88a5.512,5.512,0,0,1,.132,1.079c.019.834.008,1.668.008,2.5,0,.034,0,.069-.009.132h1.621a6.5,6.5,0,0,1,1.721.537,2.9,2.9,0,0,0-.41-.19c-.19-.07-.191-.066-.192-.271,0-.869,0-1.739,0-2.609a6.978,6.978,0,0,0-.259-2.005A6.467,6.467,0,0,0,34.1,2.612c-.254-.3-.524-.583-.8-.858A6.109,6.109,0,0,0,31.252.465,7.044,7.044,0,0,0,28.6,0Q17.837,0,7.08,0A7.381,7.381,0,0,0,5.4.17,6.952,6.952,0,0,0,1.454,2.631,6.354,6.354,0,0,0,.008,6.679Q-.013,16.249,0,25.819A7.084,7.084,0,0,0,.216,27.6a6.8,6.8,0,0,0,3.949,4.675,7.171,7.171,0,0,0,3,.574q10.673,0,21.346,0a7.931,7.931,0,0,0,1.637-.14,6.441,6.441,0,0,0,3.5-1.962,6.938,6.938,0,0,0,1.941-4.9c-.008-.834,0-1.668,0-2.5Z",
    transform: "translate(0 0)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M218.012,132.9a1.4,1.4,0,0,1-1.353,1.337,1.365,1.365,0,0,1-1.369-1.427,1.306,1.306,0,0,1,1.366-1.294,1.362,1.362,0,0,1,1.356,1.384",
    transform: "translate(-190.637 -116.453)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    d: "M186.808,89.128c0-.534-.018-1.067-.039-1.6a4,4,0,0,0-.6-1.872,3.635,3.635,0,0,0-.91-.984l-.117-.092a3.669,3.669,0,0,0-.451-.3l-.009,0a6.5,6.5,0,0,0-1.721-.537h-2.977c-1.808,0-3.616-.013-5.423.008a6.8,6.8,0,0,0-4.305,1.524,6.729,6.729,0,0,0-2.4,3.839,7.543,7.543,0,0,0-.147,1.076,6.469,6.469,0,0,0,.505,2.977,6.631,6.631,0,0,0,1.853,2.556,6.768,6.768,0,0,0,3.234,1.553,5.568,5.568,0,0,0,.8.086c2.308.087,4.618.017,6.928.039.066,0,.132,0,.2,0h.09a14.8,14.8,0,0,0,2.776-.271h0a3.82,3.82,0,0,0,1.631-1.056,3.921,3.921,0,0,0,.938-1.82,6.758,6.758,0,0,0,.126-1.357q.007-1.883,0-3.764m-2.7-.577q0,2.309,0,4.619a1.468,1.468,0,0,1-.473,1.147,1.5,1.5,0,0,1-1.041.372c-1.362,0-2.723,0-4.085,0-1.29,0-2.581,0-3.872,0a4.163,4.163,0,0,1-2.053-.5,4.062,4.062,0,0,1-2.157-3.15,4.114,4.114,0,0,1,2.691-4.336,4.541,4.541,0,0,1,1.528-.26q3.956,0,7.913,0a1.546,1.546,0,0,1,1,.307,1.426,1.426,0,0,1,.546,1.113c.009.228,0,.456,0,.685",
    transform: "translate(-148.495 -74.145)",
    fill: "#0094d1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResivePayment);
export default __webpack_public_path__ + "static/media/resive-payment.16ba83e20cd5a36478fd266d5ac0b354.svg";
export { ForwardRef as ReactComponent };